import { request } from '../Helper/Http';
import ConfigurationService from './ConfigurationService';
import { RequestConfig, Role, User } from 'tree-wallet-client';
import { UserRoles } from '../Repository/UserRepository';
import _ from "lodash";
import { IMPERSONATION_INDEX } from "./RoleService";

export async function login(
  email: string,
  password: string,
  config?: RequestConfig
) {
  await request(
    ConfigurationService.urls().loginUrl,
    {
      httpConfig: {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ username: email, password })
      },
      successCallback: (response: any) => {
        if (response && response.token) {
          setToken(response.token);
          config && config.successCallback && config.successCallback();
          return;
        }
        config && config.errorCallback && config.errorCallback({
          message: 'Invalid credentials'
        });
      },
      errorCallback: (error: any) => {
        config && config.errorCallback && config.errorCallback(error);
      }
    },
  );
}

export function isAuthenticated() {
  return !!getToken();
}

export function getToken() {
  return localStorage.getItem('token');
}

export function setToken(token: string) {
  localStorage.setItem('token', token);
}

export function removeUser() {
  localStorage.removeItem('me');
}

export function setUser(user: User) {
  localStorage.setItem('me', JSON.stringify(user));
}

export function getUser() {
  const user = localStorage.getItem('me');
  return user && JSON.parse(user);
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("me");
  localStorage.removeItem("treeCount");
  localStorage.removeItem(IMPERSONATION_INDEX);
  window.location.href = '/';
}

export function isAllowed(roles: string[], allowedRoles?: Role[]): boolean {
  if (!roles) {
    return false;
  }
  if (roles.indexOf(UserRoles.Admin.name) > -1) {
    return true;
  }

  if (!allowedRoles) {
    return false;
  }
  const roleNames = allowedRoles && allowedRoles.map(role => role.name);
  const intersection = allowedRoles && _.intersection(roles, roleNames);
  if (intersection) {
    return intersection && intersection.length > 0;
  }
  return false;
}